import { getAnonymousUserId } from '../../src/libs/anonymousUserId'
import browserEnv from '../../src/libs/env/browserEnv'

let user_id: number | undefined = undefined
export const setUserId = (id?: number) => (user_id = id)

type EventParams =
  | {
      eventType: 'home-page-view'
      productDetails: {
        product: {
          id: string
        }
      }[]
    }
  | {
      eventType: 'detail-page-view'
      productDetails: {
        product: {
          id: string
        }
      }[]
    }
  | {
      eventType: 'add-to-cart'
      productDetails: {
        product: {
          id: string
        }
        quantity: number
      }[]
    }
  | {
      eventType: 'category-page-view'
      productDetails: {
        product: {
          id: string
        }
      }[]
      pageCategories: string[]
    }
  | {
      eventType: 'purchase-complete'
      productDetails: {
        product: {
          id: string
        }
        quantity: number
      }[]
      purchaseTransaction: {
        revenue: 100.0
        currencyCode: 'JPY'
      }
    }
  | {
      eventType: 'search'
      productDetails: {
        product: {
          id: string
        }
      }[]
      searchQuery: string
    }

export const useRetail = () => {
  const sendRetailEvent = (params: EventParams) => {
    return
    const anonymousUserId = getAnonymousUserId()

    const eventParams = {
      event: 'retail',
      value: {
        visitorId: anonymousUserId,
        userInfo: {
          userId: user_id?.toString(),
        },
        uri: window.location.href,
        referrerUri: document.referrer,
        pageCategories: undefined,
        searchQuery: undefined,
        purchaseTransaction: undefined,
        ...params,
      },
    }

    if (browserEnv.NEXT_PUBLIC_GTM_ENABLED) {
      window?.dataLayer?.push(eventParams)
    }
    if (browserEnv.NEXT_PUBLIC_ENV === 'development') {
      console.log('Retail event:', params)
    }
  }

  return { sendRetailEvent }
}
